import { defineMessages } from 'react-intl';
export default defineMessages({
  description: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.description",
    defaultMessage: [{
      "type": 0,
      "value": "All related data will be deleted also"
    }]
  },
  favoriteCourses: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.favoriteCourses",
    defaultMessage: [{
      "type": 0,
      "value": "Favorite courses ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  discussions: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.discussions",
    defaultMessage: [{
      "type": 0,
      "value": "Discussions ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  userCourses: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.userCourses",
    defaultMessage: [{
      "type": 0,
      "value": "Course progress of users ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  userCoursesSubtitle: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.userCoursesSubtitle",
    defaultMessage: [{
      "type": 0,
      "value": "Including related to these lessons that are attached in another courses"
    }]
  },
  videoNotes: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.videoNotes",
    defaultMessage: [{
      "type": 0,
      "value": "Video notes ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  textNotes: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.textNotes",
    defaultMessage: [{
      "type": 0,
      "value": "Text notes ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  tasks: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.tasks",
    defaultMessage: [{
      "type": 0,
      "value": "Tasks ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  },
  assignees: {
    id: "CourseDetailsContent.ConfirmDeleteDescription.assignees",
    defaultMessage: [{
      "type": 0,
      "value": "Assignees ("
    }, {
      "type": 1,
      "value": "count"
    }, {
      "type": 0,
      "value": "):"
    }]
  }
});